import React from 'react';
import Chart from 'react-apexcharts';

const DualGroupedBarChart = () => {
  const options = {
    chart: {
      toolbar: {
        show: false // Hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
        endingShape: 'rounded',
        dataLabels: {
          enabled: false, // Disable data labels to hide the values inside the bars
        },
      },
    },
    xaxis: {
      categories: ['Jan-23', 'Feb-23', 'Mar-23', 'Apr-23', 'May-23', 'Jun-23'],
    },
    yaxis: {
      title: {
        text: 'Amount',
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels to hide the values inside the bars
    },
  };

  const series = [
    {
      name: 'Target',
      data: [300000, 100000, 80000, 50000, 200000, 250000],
      color: '#0a2352',
  
    },
    {
      name: 'Collections',
      data: [200000, 60000, 50000, 40000, 150000, 150000],
      color: '#0a2360',
      
    },
  ];

  return (
    <div>
      
      <Chart options={options} series={series} type="bar" height={200} />
    </div>
  );
};

export default DualGroupedBarChart;




// import React from 'react';
// import ReactApexChart from 'react-apexcharts';

// const DualGroupedBarChart = () => {
//   const series = [
//     {
//       name: 'Target',
//       data: [300000, 100000, 80000, 50000, 200000, 250000],
//       color: '#0a2352',
//       type: 'column',
      
//     },
//     {
//       name: 'Collections',
//       data: [200000, 60000, 50000, 40000, 150000, 150000],
//       color: '#0a2360',
//       type: 'column',
//     }
//   ];

//   const options = {
//     chart: {
//       height: 350,
//       type: 'line',
//       stacked: false
//     },
//     dataLabels: {
//       enabled: false
//     },
//     stroke: {
//       width: [1, 1]
//     },
//     // title: {
//     //   text: 'Amount',
//     //   align: 'left',
//     //   offsetX: 110
//     // },
//     xaxis: {
//       categories: ['Jan-23', 'Feb-23', 'Mar-23', 'Apr-23', 'May-23', 'Jun-23'],
//     },
//     yaxis: [
//       {
//         axisTicks: {
//           show: true,
//         },
//         axisBorder: {
//           show: true,
//           // color: '#008FFB'
//         },
//         // labels: {
//         //   style: {
//         //     colors: '#008FFB',
//         //   }
//         // },
//         title: {
//           text: "Amount",
//           // style: {
//           //   color: '#008FFB',
//           // }
//         },
//         tooltip: {
//           enabled: true
//         }
//       },
//       {
//         seriesName: 'Income',
//         opposite: true,
//         axisTicks: {
//           show: true,
//         },
//         axisBorder: {
//           show: true,
//           // color: '#00E396'
//         },
//         // labels: {
//         //   style: {
//         //     colors: '#00E396',
//         //   }
//         // },
//         title: {
//           text: "Amount",
//           // style: {
//           //   color: '#00E396',
//           // }
//         },
//       },
//     ],
//     tooltip: {
//       fixed: {
//         enabled: true,
//         position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
//         offsetY: 30,
//         offsetX: 60
//       },
//     },
//     // legend: {
//     //   horizontalAlign: 'left',
//     //   offsetX: 40
//     // }
//   };

//   return (
//     <div id="chart">
//       <ReactApexChart options={options} series={series} type="line" height={170} />
//     </div>
//   );
// };

// export default DualGroupedBarChart;
